import { inject, Injectable } from '@angular/core';

import { of } from 'rxjs';

import type { DataSourceService } from '@recruitee/views-types';

import { CandidateDialogService } from '../../../main/candidate-dialog.service';
import { CandidateSearchComponent } from './search/candidates-search.component';

@Injectable()
export class CandidatesDataSourceService implements DataSourceService {
  public hasMoreSettings$ = of(true);
  public hasSampleData$ = of(false);
  public isSampleDataInProgress$ = of(false);
  public viewPageHeaderComponent$ = of(null);
  public pageCtaVisible$ = of(false);

  public refreshData$ = of(undefined);
  public translations = {
    dataSourceName: 'app.views_candidates.name',
    pageCta: 'app.views_candidates.view_add_candidate',
  };

  public defaultEmptyState$ = of({
    header: '',
    description: '',
    icon: <any>'',
  });

  public filteredEmptyState$ = of({
    header: '',
    description: '',
    icon: <any>'',
  });

  public searchComponent = CandidateSearchComponent;

  private candidateDialogService = inject(CandidateDialogService);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onRemoveSampleData = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onPageCtaClick = () => {};

  public onRecordClick = (candidate: { id: number }) => {
    this.candidateDialogService.open({ candidate: candidate.id });
  };
}
